import { render, staticRenderFns } from "./DlgGroupNew.vue?vue&type=template&id=ad8e58e4&scoped=true"
import script from "./DlgGroupNew.vue?vue&type=script&lang=js"
export * from "./DlgGroupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8e58e4",
  null
  
)

export default component.exports